module.exports = __webpack_public_path__ + "static/media/Christen-K._160px.08825c93.jpg";